module.exports = __webpack_public_path__ + "static/media/icon-loading-flower.0380a26f.gif";